module.exports = __webpack_public_path__ + "img/loginback.50920d69.png";